import gql from 'graphql-tag'
export const fetchAddFreeBeerToCartMutation = gql(`
mutation ($id: Int , $qty: Float, $product_id: Int ,$operate_flag: String!) {
    freeBeerCart(
        input:{
            id: $id,
            qty: $qty,
            product_id: $product_id,
            operate_flag: $operate_flag
        }
    ){
        success_message
        error_message
        iFreebeerProductCartQty
        iFillUpLayerQty
        item_id

    }
}`)
